import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { CONFIGURATION_BASIC } from '../../constants/queryKeys';
import { ApiCalls } from '../../api/api';
import { TimeUserFeatures } from '../../api/generated/data-contracts';

export const useTimeUIConfig = (
    options?: Omit<UseQueryOptions<TimeUserFeatures, unknown, TimeUserFeatures, string[]>, 'initialData' | 'queryKey' | 'queryFn'> & {
        initialData?: () => undefined;
    },
) => {
    const { data, ...rest } = useQuery({
        queryKey: [CONFIGURATION_BASIC],
        queryFn: () => ApiCalls.configurationBasicList().then(res => res.data),
        staleTime: Infinity,
        cacheTime: Infinity,
        suspense: true,
        ...options,
    });
    return {
        config: data,
        ...rest,
    };
};
